import { fallback } from '@logto/core-kit';
import { languages } from '@logto/language-kit';
import { z } from 'zod';
import de from './locales/de/index.js';
import en from './locales/en/index.js';
import fr from './locales/fr/index.js';
import ko from './locales/ko/index.js';
import ptPT from './locales/pt-pt/index.js';
import trTR from './locales/tr-tr/index.js';
import zhCN from './locales/zh-cn/index.js';
export const builtInLanguages = ['de', 'en', 'fr', 'ko', 'pt-PT', 'tr-TR', 'zh-CN'];
export const builtInLanguageOptions = builtInLanguages.map((languageTag) => ({
    value: languageTag,
    title: languages[languageTag],
}));
export const builtInLanguageTagGuard = z.enum(builtInLanguages);
export const getDefaultLanguageTag = (languages) => builtInLanguageTagGuard.or(fallback('en')).parse(languages);
export const isBuiltInLanguageTag = (language) => builtInLanguageTagGuard.safeParse(language).success;
const resource = {
    de,
    en,
    fr,
    ko,
    'pt-PT': ptPT,
    'tr-TR': trTR,
    'zh-CN': zhCN,
};
export default resource;
